import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import BigTableModal from "../../../../Dashboard/pages/dashboard/admin_portal_comp/ExpandViews/BigTableModal";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../../../../../_metronic/_helpers";
import { formatNumberWithCommas } from "../../../../../utils/common";
import { Link } from "react-router-dom";
import DonutChart from "../../../../../../component/DonutChart";
import { useSelector, shallowEqual } from "react-redux";

export function EmployeeLoanDetail({ entities }) {
  const [modalData, setModalData] = useState(null);
  const { loan } = useSelector(
    (state) => ({
      loan: state?.auth?.userAccess["Payroll"],
      // appraisal: state?.auth?.userAccess["appraisal_evaluation"],
    }),
    shallowEqual
  );

  const isLoanRequest = loan?.find(
    (el) => el?.componentName === "ReadAllLoanRequest" && el?.isResourceShow
  );
  const isPayslip = loan?.find(
    (el) => el?.componentName === "ReadPayslip" && el?.isResourceShow
  );

  // const isAppraisalEvaluation = appraisal?.find(
  //   (el) =>
  //     el?.componentName === "ReadAllAppraisalEvaluation" && el?.isResourceShow
  // );

  const columns = [
    {
      dataField: "LoanType.name",
      text: "Loan Type",
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: {
        maxWidth: "80px",
      },
    },
    {
      dataField: "total_loan_amount",
      text: "Amount",
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: {
        maxWidth: "10px",
        // textAlign: "right",
      },
      // headerStyle: {
      //   textAlign: "center", // Align header text to the left
      // },
      formatter: (cell) => formatNumberWithCommas(cell),
    },
    {
      dataField: "loan_amount_paid",
      text: "Paid",
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: {
        maxWidth: "10px",
        // textAlign: "center",
      },
      // headerStyle: {
      //   textAlign: "center", // Align header text to the left
      // },
      formatter: (cell) => formatNumberWithCommas(cell),
    },
    {
      dataField: "loan_amount_remaining",
      text: "Outstanding",
      sort: false,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: {
        maxWidth: "10px",
        // textAlign: "center",
      },
      // headerStyle: {
      //   textAlign: "center", // Align header text to the left
      // },
      formatter: (cell) => formatNumberWithCommas(cell),
    },
  ];

  return (
    <div className="px-3 py-2 w-full bg-white rounded-lg">
      <div className="w-full text-xs px-3 py-2  flex flex-col h-full justify-between">
        <div className="w-full">
          <h6 className="font-bold mb-0 text-primary my-2">Loan & Payslip</h6>
          <DonutChart
            data={
              Array.isArray(entities)
                ? entities.map((item) => ({
                    label: item.LoanType?.name,
                    value: item?.loan_amount_remaining,
                  }))
                : []
            }
            onItemClick={(item) => {
  const selectedLoanType = item?.label;

  const filteredData = (entities || [])
    .filter((loan) => loan?.LoanType?.name === selectedLoanType)
    .map((loan) => ({
      Loan_Type: loan?.LoanType?.name || "",
      Loan_Amount: formatNumberWithCommas(loan?.total_loan_amount),
      Installment_Amount: formatNumberWithCommas(loan?.monthly_installment),
      Loan_Paid: formatNumberWithCommas(loan?.loan_amount_paid),
      Loan_Outstanding: formatNumberWithCommas(loan?.loan_amount_remaining),
    }));

  setModalData({
    data: filteredData,
    dashlet_name: "Loan Details",
  });
}}
          />
        </div>
        <div>
          <BootstrapTable
            noDataIndication={NoRecordsFoundMessage({
              entities: entities || [],
            })}
            wrapperClasses="table-responsive"
            bordered={false}
            classes="table table-head-custom table-vertical-center overflow-hidden table-hover"
            bootstrap4
            remote
            keyField="Id"
            data={entities || []}
            columns={columns}
          >
            <PleaseWaitMessage entities={entities || []} />
            <NoRecordsFoundMessage entities={entities || []} />
          </BootstrapTable>
        </div>
        <div className="font-size-xs font-semibold flex gap-x-4 items-end text-black mt-2 flex-wrap">
          <p className="m-0 underline hover:text-primary">
            {isLoanRequest ? (
              <a href={"/loan_request/read-all-loan-request"}>
                Loan Request{" "}
              </a>
            ) : (
              <label className="opacity-50 cursor-not-allowed">
                Loan Request
              </label>
            )}
          </p>
          <p className="m-0 underline">
            {isPayslip ? (
              <a href={"/payslip/read-payslip"}>Payslip</a>
            ) : (
              <label className="opacity-50 cursor-not-allowed">Payslip</label>
            )}
          </p>

        </div>
      </div>
      <BigTableModal
  show={!!modalData}
  data={modalData}
  onHide={() => {
    setModalData(null);
  }}
/>
    </div>
  );
}
